import React, { useEffect, useState } from "react";
import { Input, Button, Select, Checkbox, Tooltip, Collapse } from "antd";
import {
  setX_attribute,
  setY_attribute,
} from "../../../redux/actions/WidgetMaker/GraphConfig";
import { useDispatch, useSelector } from "react-redux";
import { setChartEditField } from "../../../redux/actions/WidgetMaker/GraphConfig";
import {
  callNotification,
  getCustomizedDate,
  getEmptyFieldNotification,
  getWidgetMakerFlag,
  updateChartSettingsInGraphObjectBasedOnSelection,
} from "../../../redux/constants";
import moment from "moment";
import { setWidgetMakerGraphData } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import { getTimeIntervalForDate } from "../../../redux/constants";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import WordCloudColorPalate from "../WordCloudColorPalate";
import AttributeConfigurePanel from "../AttributeConfig";
import { supportedBenchmarkTraceChartTypes } from "../../../redux/constants/enums";
const { Panel } = Collapse;
const { TextArea } = Input;
const EditFieldPanel = ({
  setEditPanel,
  editName,
  setEditName,
  editPanel,
  editseries,
  yData,
  editAggregation,
  setAggregation,
  onApply,
  onEditXlimitChange,
}) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);
  const [islimet, setIslimet] = useState(false);
  const [infoText, setInfoText] = useState("");
  const [editDatePart, setEditDatePart] = useState();
  const [editSortOrder, setEditSortOrder] = useState("desc");
  const [editXlimit, setEditXlimit] = useState();
  const [collapseActiveKey, setCollapseActiveKey] = useState([]);
  const [editXlimitError, setEditXlimitError] = useState(false);
  const [attrLevelObjectforXaxis, setAttrLevelObjectforXaxis] = useState(null);
  const [attrLevelObjectforBreakdown, setAttrLevelObjectforBreakdown] =
    useState(null);
  const [originalName, setOriginalName] = useState("");
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const graphConditionAggregation = useSelector(
    (state) => state?.apiCall?.graphConditions?.column_aggregations
  );
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const radioArray = useSelector((state) => state.Filter.radioArray);
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const [percent, setPercent] = useState(false);
  const [spaningOn, setSpaningOn] = useState(false);
  const [variableSizeOn, setVariableSizeOn] = useState(false);
  const [optionList, setOptionList] = useState({
    timeList: [],
    defaultVal: [],
  });
  const [radiusAttribute, setRadiusAttribute] = useState(null);
  const [radiusOptions, setRadiusOptions] = useState(null);
  const [seriesColor, setSeriesColor] = useState(null);
  // this useEffect is for duration updating
  useEffect(() => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    let yAxesDateAttr =
      widgetGraphConfig?.breakdown_by &&
      Array.isArray(widgetGraphConfig?.breakdown_by)
        ? widgetGraphConfig?.breakdown_by?.some((y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            )
          )
          ? widgetGraphConfig?.breakdown_by?.find((y_axis) =>
              graphConditionConfig?.["date-attributes"]?.includes(
                y_axis?.attribute
              )
            )
          : null
        : null;
    let getInterval = getTimeIntervalForDate(
      widgetGraphConfig ? widgetGraphConfig?.duration?.to : defaultDuration?.to,
      widgetGraphConfig
        ? widgetGraphConfig?.duration?.from
        : defaultDuration?.from,
      widgetGraphConfig?.chart_type,
      yAxesDateAttr?.attribute
        ? yAxesDateAttr?.attribute
        : widgetGraphConfig?.x_axis?.attribute
    );

    setOptionList({
      timeList: getInterval?.timeList,
      defaultVal: getInterval?.defaultVal,
    });
  }, [widgetGraphConfig?.duration]);
  useEffect(() => {
    if (
      Array.isArray(graphConditions?.["network-graph"]?.order_by?.include) &&
      graphConditions?.["network-graph"]?.order_by?.include?.length > 0
    ) {
      let options = graphConditions?.["network-graph"]?.order_by?.include
        ?.map((attributeObj) => {
          if (attributeObj) {
            let attr = {
              attribute: attributeObj?.value,
              trace_name:
                attributeObj?.text === "All hubs equal"
                  ? "All Equal Hubs"
                  : attributeObj?.text,
            };
            return attr;
          } else {
            return null;
          }
        })
        ?.filter((e) => e);
      setRadiusOptions(options?.length > 0 ? options : []);
    }
  }, [graphConditions?.["network-graph"]?.order_by?.include]);

  // this is for all the option changes in edit panel
  useEffect(() => {
    let selectedCardCount =
      editPanel?.card_data?.response?.[editPanel?.card_data?.card_name - 1]
        ?.data?.length;
    const originalNameValue =
      editPanel.series === "x_axis" && axisPanelAtt.x_axis?.trace_name
        ? axisPanelAtt?.x_axis?.trace_name
        : editPanel.series.split("_")[0] === "y" &&
          axisPanelAtt?.y_axis[editPanel.series]?.trace_name
        ? axisPanelAtt?.y_axis[editPanel.series]?.trace_name
        : editPanel.series?.split("_")[0] === "kpi" &&
          editPanel?.values_trace_name
        ? editPanel?.values_trace_name
        : editPanel.series === "group_by"
        ? editPanel?.values_trace_name
          ? editPanel?.values_trace_name
          : All_WM_attributes[editPanel.card_data?.x_axis?.attribute] +
            " With " +
            All_WM_attributes[editPanel.card_data?.y_series?.attribute]
        : editPanel?.series === "filter_by"
        ? axisPanelAtt?.filter_by[0]?.trace_name &&
          axisPanelAtt?.filter_by[0]?.trace_name !==
            axisPanelAtt?.filter_by[0]?.attribute
          ? axisPanelAtt?.filter_by[0]?.trace_name
          : All_WM_attributes[axisPanelAtt?.filter_by[0]?.attribute]
        : editPanel?.series === "filter_dropdown"
        ? axisPanelAtt?.filter_dropdown[editPanel?.breakdown_index]
            ?.trace_name &&
          axisPanelAtt?.filter_dropdown[editPanel?.breakdown_index]
            ?.trace_name !==
            axisPanelAtt?.filter_dropdown[editPanel?.breakdown_index]?.attribute
          ? axisPanelAtt?.filter_dropdown[editPanel?.breakdown_index]
              ?.trace_name
          : All_WM_attributes[
              axisPanelAtt?.filter_dropdown[editPanel?.breakdown_index]
                ?.attribute
            ]
        : All_WM_attributes[editPanel.attName];
    setEditName(originalNameValue);
    setOriginalName(originalNameValue);
    setInfoText(
      (editPanel.series?.split("_")[0] === "kpi" ||
        (editPanel?.chart_type === "kpi" &&
          !axisPanelAtt?.x_axis?.attribute)) &&
        editPanel?.info_text
        ? editPanel?.info_text
        : ""
    );
    setAggregation(
      editPanel?.values_aggregation === "avg"
        ? "avg"
        : editPanel?.values_aggregation === "SUM"
        ? "Sum"
        : editPanel?.values_aggregation === "COUNT"
        ? "count"
        : editPanel.series === "y_series_1"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_2"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_3"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_4"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_5"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_6"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_7"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_8"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_9"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series === "y_series_10"
        ? editPanel?.aggregation === "COUNT"
          ? "count"
          : editPanel?.aggregation === "SUM"
          ? "Sum"
          : editPanel?.aggregation
        : editPanel.series?.split("_")[0] === "kpi"
        ? editPanel?.values_aggregation
        : "count"
    );
    setEditSortOrder(
      editPanel.series === "x_axis" || editPanel.series === "filter_dropdown"
        ? editPanel?.x_axis_sort_order
          ? editPanel?.x_axis_sort_order
          : "desc"
        : editPanel.series === "group_by"
        ? editPanel?.group_by_sort_order
          ? editPanel?.group_by_sort_order
          : "desc"
        : "desc"
    );
    // console.log("editPanel", editPanel,"selectedCardCount",selectedCardCount);
    setEditXlimit(
      editPanel?.series === "multilevel_breakdown"
        ? editPanel?.y_axis_y_limit
        : editPanel?.series === "x_axis"
        ? // For Grid chart types, set limit to null by default
          editPanel?.chart_type === "grid"
          ? editPanel?.x_axis_x_limit === null ||
            editPanel?.x_axis_x_limit === undefined
            ? null
            : editPanel?.x_axis_x_limit
          : editPanel?.x_axis_x_limit === null
          ? 20
          : editPanel?.x_axis_x_limit
        : editPanel?.series === "group_by"
        ? selectedCardCount < 5
          ? selectedCardCount
          : editPanel?.group_by_x_limit
        : editPanel?.series === "breakdown"
        ? editPanel?.y_axis_y_limit
          ? editPanel?.y_axis_y_limit
          : editPanel?.chart_type === "pivot-grid"
          ? 5
          : 20
        : editPanel?.series === "filter_dropdown"
        ? editPanel?.y_axis_y_limit
          ? editPanel?.y_axis_y_limit
          : editPanel?.chart_type === "pivot-grid"
          ? 5
          : 20
        : 20
    );
    setEditDatePart(
      editPanel.series === "breakdown" || editPanel.series === "filter_dropdown"
        ? editPanel?.x_axis_date_part === null
          ? "null"
          : editPanel?.x_axis_date_part
        : editPanel.series === "x_axis" &&
          editPanel?.chart_type !== "pie" &&
          editPanel?.chart_type !== "donut"
        ? editPanel?.x_axis_date_part === null
          ? "null"
          : editPanel?.x_axis_date_part
        : editPanel.series === "x_axis" && editPanel?.chart_type === "pie"
        ? editPanel?.x_axis_date_part
        : editPanel.series === "x_axis" && editPanel?.chart_type === "donut"
        ? editPanel?.x_axis_date_part
        : optionList?.defaultVal
        ? optionList?.defaultVal
        : "null"
    );
    setPercent(editPanel?.chart_type === "grid" ? editPanel?.percent : false);
    setRadiusAttribute(
      editPanel?.radius_attribute ? editPanel?.radius_attribute : null
    );
    setSeriesColor(editPanel?.seriesColor ? editPanel?.seriesColor : null);
    setSpaningOn(editPanel?.chart_type === "grid" ? editPanel?.span_on : false);

    setVariableSizeOn(
      editPanel?.chart_type === "scatter" ? editPanel?.variable_size : false
    );
    // Calculate the initial editXlimit value
    const initialEditXlimit =
      editPanel?.series === "x_axis"
        ? editPanel?.x_axis_x_limit === null
          ? 20
          : editPanel?.x_axis_x_limit
        : editPanel?.series === "group_by"
        ? selectedCardCount < 5
          ? selectedCardCount
          : editPanel?.group_by_x_limit
        : editPanel?.series === "breakdown"
        ? editPanel?.y_axis_y_limit
          ? editPanel?.y_axis_y_limit
          : editPanel?.chart_type === "pivot-grid"
          ? 5
          : 20
        : 20;

    // Call onEditXlimitChange with the initial value
    if (onEditXlimitChange) {
      onEditXlimitChange(initialEditXlimit);
    }
  }, [editseries, editPanel]);

  const handleCheckBox = (e) => {
    setPercent(!percent);
  };

  const callChartAPI = (graphConfig) => {
    dispatch(setOptionHighChart({}));
    let y_series_array = [];
    y_series_array = graphConfig?.y_axis
      ? Object.keys(graphConfig.y_axis).map((key) => graphConfig.y_axis[key])
      : [];
    y_series_array = y_series_array?.filter((el) => el?.attribute);
    if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie"
    ) {
      y_series_array =
        y_series_array?.length > 1 ? [y_series_array[0]] : y_series_array;
    }

    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    let card_settings_data = [];
    graphConfig?.card_settings?.map((d) => {
      if (
        (d?.x_axis?.attribute || (!d?.x_axis?.attribute && d?.y_series)) &&
        d?.y_series?.attribute
      ) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series?.attribute ? d?.y_series : null,
          },
        ];
      }
    });

    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let graphObject = {
      brand_list: [
        {
          brand_id: 600,
        },
      ],
      data_source: data_source,
      start_date: widgetGraphConfig?.duration?.from
        ? widgetGraphConfig?.duration?.from
        : defaultDuration?.from,
      end_date: widgetGraphConfig?.duration?.to
        ? widgetGraphConfig?.duration?.to
        : defaultDuration?.to,
      brands: widgetGraphConfig?.brands
        ? widgetGraphConfig?.brands
        : brandlogicalgroup?.length > 0
        ? brandlogicalgroup
        : brands,
      isBrandModified: widgetGraphConfig?.brands ? true : false,

      filters:
        widgetGraphConfig?.filters?.length > 0
          ? widgetGraphConfig?.filters
          : [],
      x_axis: widgetGraphConfig?.x_axis && widgetGraphConfig?.x_axis,
      // Break down data
      y_axes:
        widgetGraphConfig?.breakdown_by?.length > 0
          ? widgetGraphConfig?.breakdown_by
          : null,
      // y axis data
      y_series: y_series_array && y_series_array,
      widget_name: "abc",
      chart: {
        chart_type:
          widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type,
        rich_fields_content: widgetGraphConfig?.rich_fields_content,
        chart_settings: {
          ...widgetGraphConfig?.chart_settings,
          // //duration_comparison: true,
          // duration_comparison: false, // This is used for only KPI
          // show_previous_duration_comparison: false, // This is used for charts
          // show_previous_duration_data: false, // This is used for charts
          // show_data_labels: true,
          // is_stacked: true,
          // show_count_cards: true,
          // card_percent: true,
          // chart_percent: false,
          // gradient_color: false,
          // split_cards: widgetGraphConfig?.chart_settings?.split_cards,
          // top_posts_in_cards:
          //   widgetGraphConfig?.chart_settings?.top_posts_in_cards,

          show_data_labels:
            widgetGraphConfig?.chart_settings?.global_data_label,
          show_details_on_card:
            widgetGraphConfig?.chart_settings?.show_details_on_card,
          show_as_median: widgetGraphConfig?.chart_settings?.show_as_median,
          show_3d: widgetGraphConfig?.chart_settings?.show_3d,
          settings_3d: widgetGraphConfig?.chart_settings?.settings_3d,
          show_label_names: widgetGraphConfig?.chart_settings?.show_label_names,
          show_count_cards: widgetGraphConfig?.chart_settings?.data_count_card,
          top_posts_in_cards:
            widgetGraphConfig?.chart_settings?.top_posts_in_cards,
          show_header:
            typeof widgetGraphConfig?.chart_settings?.show_header === "boolean"
              ? widgetGraphConfig?.chart_settings?.show_header
              : true,
          chart_property: {
            chart_name: "Line chart",
            legend_position: "top",
            y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
            no_of_top_posts: widgetGraphConfig?.chart_property?.no_of_top_posts,
          },
          y_axes_settings: widgetGraphConfig?.y_axis_settings,
          cards_settings: card_settings_data ? card_settings_data : null,
          chart_styles: widgetGraphConfig?.chart_settings?.chart_styles || null,
          cluster_chart_type:
            widgetGraphConfig?.chart_settings?.cluster_chart_type,
          cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
        },
      },
      card_settings_index: graphConfig?.card_settings?.length - 1,
      widgetGraphConfig: graphConfig,
      order_by:
        widgetGraphConfig?.chart_type === "post-card" ||
        widgetGraphConfig?.chart_type === "review-card" ||
        widgetGraphConfig?.chart_type === "author-card" ||
        widgetGraphConfig?.chart_type === "prolific-user"
          ? widgetGraphConfig?.order_by
          : null,
      utcOffset: utcOffset,
      edit: widgetGraphConfig?.edit,
      tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],
      multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown || null,
    };
    // Check and update chart settings based on benchmark line case
    let updatedGraphObject = updateChartSettingsInGraphObjectBasedOnSelection({
      widgetGraphConfig: widgetGraphConfig,
      brandlogicalgroup: brandlogicalgroup,
      brands: brands,
      graphObject: graphObject,
    });
    if (updatedGraphObject) {
      graphObject = updatedGraphObject;
    }
    if (widgetGraphConfig?.chart_type === "network-graph-v2") {
      graphObject.isNetworkChartV2 =
        graphObject?.chart?.chart_type === "network-graph-v2" ? true : false;
    }
    if (
      graphConfig?.card_settings[graphConfig?.card_settings?.length - 1]
        ?.x_axis ||
      graphConfig?.card_settings[graphConfig?.card_settings?.length - 1]
        ?.y_series
    ) {
      authParams &&
        graphConfig?.card_settings?.length - 1 >= 0 &&
        dispatch(setWidgetMakerGraphData(authParams, graphObject));
    }
  };
  const handleUpdatedAttrLevelBreakdown = (updatedBreakdown) => {
    setAttrLevelObjectforBreakdown(updatedBreakdown);
  };
  const handleUpdatedAttrLevelXaxis = (updatedXaxis) => {
    setAttrLevelObjectforXaxis(updatedXaxis);
  };
  // this runs on the apply button
  const applyEditPanel = () => {
    let openCard = false;
    if (editPanel?.card_data && editPanel?.chart_type !== "sankey") {
      axisPanelAtt?.card_settings?.map((item, itemIndex) => {
        if (!item?.x_axis && !item?.y_series) {
          openCard = true;
        }
      });
    }
    let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);
    if (
      !y_series_flag?.flag &&
      !openCard &&
      editPanel?.chart_type !== "sankey"
    ) {
      if (editseries === "x_axis") {
        dispatch(
          setX_attribute({
            ...axisPanelAtt,
            [`x_axis`]: {
              attribute: editPanel.attName,
              data_source: editPanel?.data_source,
              deep_dive_info: axisPanelAtt?.x_axis?.deep_dive_info
                ? axisPanelAtt?.x_axis?.deep_dive_info
                : editPanel?.deep_dive_info,
              trace_name: editName,
              aggregation: editAggregation,
              date_part:
                All_WM_attributes[editPanel.attName] === "Date" ||
                editPanel.attName === "RecordDate" ||
                editPanel.attName === "recorddate" ||
                editPanel.attName === "InsertedDate"
                  ? editDatePart === "null"
                    ? null
                    : editDatePart
                  : null,
              frequency: null,
              sort_order: editSortOrder,
              x_limit: parseInt(editXlimit),
              radius_attribute: radiusAttribute,
              color: seriesColor,
              span_on: spaningOn,
              config_filters: attrLevelObjectforXaxis?.config_filters,
            },
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
            },
          })
        );
      } else if (editseries === "order_by") {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`order_by`]: {
              attribute: editPanel.attName,
              sort_order: editSortOrder,
              limit: parseInt(editXlimit),
            },
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
            },
          })
        );
      } else if (editseries?.split("_")[0] === "y") {
        let result2 = [];

        let data = radioArray[editseries]?.data;

        var myMap = new Map();
        if (data?.length) {
          for (let i in data) {
            if (myMap?.has(data[i]?.attribute)) {
              let value = myMap.get(data[i]?.attribute);
              let columnsArray = value.columns; // copy columns array
              columnsArray?.push({
                name: data[i]?.name,
                type: data[i]?.type,
              });

              myMap.set(data[i]?.attribute, {
                attribute: data[i]?.attribute,
                type: data[i]?.datatype,
                columns: columnsArray,
              });
            } else {
              myMap.set(data[i]?.attribute, {
                attribute: data[i]?.attribute,
                type: data[i]?.datatype,
                columns: [
                  {
                    name: data[i]?.name,
                    type: data[i]?.type,
                  },
                ],
              });
            }
          }

          for (const [, value] of myMap.entries()) {
            result2.push(value);
          }
        }

        let filterValue = result2.filter((item) => {
          return (
            item.attribute !== "" &&
            item.attribute !== undefined &&
            item.columns !== undefined
          );
        });

        let ySeries = {};
        if (axisPanelAtt?.y_axis) {
          Object.entries(axisPanelAtt.y_axis).forEach((e) => {
            if (e[0] === editseries) {
              ySeries = {
                ...ySeries,
                [e[0]]: {
                  ...e[1],
                  filters:
                    filterValue?.length > 0 ? filterValue : e[1]?.filters,
                  attribute: editPanel?.attName,
                  data_source: editPanel?.data_source,
                  deep_dive_info: e[1]?.deep_dive_info
                    ? e[1]?.deep_dive_info
                    : editPanel?.deep_dive_info,
                  trace_name: editName,
                  percent: percent,
                  aggregation: editAggregation,
                  info_text: infoText,
                  variable_size: variableSizeOn,
                },
              };
            } else {
              ySeries = { ...ySeries, [e[0]]: { ...e[1] } };
            }
          });
        }

        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`y_axis`]: {
              ...ySeries,
            },
            // [`edit_fields`]: {
            //   ...axisPanelAtt?.edit_fields,
            //   boolValue: false,
            // },
          })
        );
      } else if (editseries === "breakdown") {
        // check is_pivot or not
        // based on index update the limit of breakdown

        const updatedBreakdown = axisPanelAtt?.breakdown_by?.map((d, i) => {
          let dateAtt =
            [
              "pivot-grid",
              "combination",
              "bar",
              "horizontal-bar",
              "lollipop",
              "area",
              "line",
              "heatmap",
            ]?.includes(editPanel?.chart_type) &&
            editPanel.series === "breakdown"
              ? editDatePart === "null"
                ? null
                : editDatePart
              : All_WM_attributes[editPanel.attName] === "Date" ||
                editPanel.attName === "RecordDate" ||
                editPanel.attName === "recorddate" ||
                editPanel.attName === "InsertedDate"
              ? editDatePart === "null"
                ? null
                : editDatePart
              : null;
          if (i === editPanel?.breakdown_index) {
            d.attribute = editPanel?.attName;
            d.data_source = editPanel?.data_source;
            d.deep_dive_info = d?.deep_dive_info
              ? d?.deep_dive_info
              : editPanel?.deep_dive_info;
            d.trace_name = editName;
            d.aggregation = editAggregation;
            d.y_limit = parseInt(editXlimit);
            d.date_part = dateAtt;
            d.radius_attribute = radiusAttribute;
            d.color = seriesColor;
            d.span_on = spaningOn;
            d.config_filters = attrLevelObjectforBreakdown?.[i]?.config_filters;
          }
          if (d?.date_aggregation) delete d?.date_aggregation;
          return d;
        });

        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`breakdown_by`]: [...updatedBreakdown],
            [`edit_fields`]: {
              ...axisPanelAtt?.edit_fields,
              boolValue: false,
            },
          })
        );
      } else if (editseries === "group_by") {
        let cards =
          axisPanelAtt?.card_settings?.[axisPanelAtt?.card_settings?.length - 1]
            ?.response;
        let totalCount = 0;
        let selectedCardIndex = editPanel?.card_data?.card_name - 1;

        cards?.map((d, i) => {
          if (i !== selectedCardIndex) {
            d?.data?.map((e) => {
              totalCount = totalCount + 1;
            });
          }
        });
        let totalCardCount = parseInt(totalCount) + parseInt(editXlimit);

        if (parseInt(editXlimit) === 0 || parseInt(editXlimit) < 1) {
          callNotification("Card limit should be greater than 0", "error");
        } else if (totalCardCount <= 15 && editXlimit > 0) {
          const filteredCard = axisPanelAtt?.card_settings?.map((item) => {
            if (editPanel?.card_id == item?.card_id) {
              item.x_axis.sort_order = editSortOrder;
              item.x_axis.x_limit = parseInt(editXlimit);
              item.x_axis.trace_name = editName;
            }
            return item;
          });
          let graphConfig = {
            ...axisPanelAtt,
            [`card_settings`]: [...filteredCard],
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
            },
          };
          dispatch(setY_attribute(graphConfig));
          // callChartAPI(graphConfig);
        } else {
          callNotification("KPI cards limit reached", "error");
        }
      } else if (editseries?.split("_")[0] === "kpi") {
        let result2 = [];

        let data = radioArray[editseries]?.data;

        var myMap = new Map();
        if (data?.length) {
          for (let i in data) {
            if (myMap?.has(data[i]?.attribute)) {
              let value = myMap.get(data[i]?.attribute);
              let columnsArray = value.columns; // copy columns array
              columnsArray?.push({
                name: data[i]?.name,
                type: data[i]?.type,
              });

              myMap.set(data[i]?.attribute, {
                data_source: data_source,
                attribute: data[i]?.attribute,
                type: data[i]?.datatype,
                columns: columnsArray,
              });
            } else {
              myMap.set(data[i]?.attribute, {
                data_source: data_source,
                attribute: data[i]?.attribute,
                type: data[i]?.datatype,
                columns: [
                  {
                    name: data[i]?.name,
                    type: data[i]?.type,
                  },
                ],
              });
            }
          }

          for (const [, value] of myMap.entries()) {
            result2.push(value);
          }
        }

        let filterValue = result2.filter((item) => {
          return (
            item.attribute !== "" &&
            item.attribute !== undefined &&
            item.columns !== undefined
          );
        });

        let card_settings = [];
        axisPanelAtt?.card_settings?.forEach((el, i) => {
          if (el?.card_name === Number(editseries?.split("_")[2])) {
            card_settings = [
              ...card_settings,
              {
                ...el,
                y_series: {
                  ...el?.y_series,
                  filters:
                    filterValue?.length > 0
                      ? filterValue
                      : el?.y_series?.filters,
                  attribute: editPanel?.attName,
                  data_source: data_source,
                  trace_name: editName,
                  percent: percent,
                  aggregation: editAggregation,
                  info_text: infoText,
                },
              },
            ];
          } else {
            card_settings = [...card_settings, el];
          }
        });
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`card_settings`]: [...card_settings],
            [`edit_fields`]: {
              ...axisPanelAtt?.edit_fields,
              boolValue: false,
            },
          })
        );
      } else if (editseries === "filter_by") {
        const updatedFilterBy = axisPanelAtt?.filter_by?.map((d, i) => {
          if (d?.attribute === editPanel?.attName) {
            d.trace_name = editName;
          }
          return d;
        });

        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`filter_by`]: [...updatedFilterBy],
            [`edit_fields`]: {
              ...axisPanelAtt?.edit_fields,
              boolValue: false,
            },
          })
        );
      } else if (editseries === "filter_dropdown") {
        const updatedFilterDropdown = axisPanelAtt?.filter_dropdown?.map(
          (d, i) => {
            let dateAtt =
              [
                "pivot-grid",
                "combination",
                "bar",
                "horizontal-bar",
                "lollipop",
                "area",
                "line",
                "heatmap",
              ]?.includes(editPanel?.chart_type) &&
              editPanel.series === "filter_dropdown"
                ? editDatePart === "null"
                  ? null
                  : editDatePart
                : All_WM_attributes[editPanel.attName] === "Date" ||
                  editPanel.attName === "RecordDate" ||
                  editPanel.attName === "recorddate" ||
                  editPanel.attName === "InsertedDate"
                ? editDatePart === "null"
                  ? null
                  : editDatePart
                : null;
            if (i === editPanel?.breakdown_index) {
              d.attribute = editPanel?.attName;
              d.data_source = editPanel?.data_source;
              d.deep_dive_info = d?.deep_dive_info
                ? d?.deep_dive_info
                : editPanel?.deep_dive_info;
              d.trace_name = editName;
              d.aggregation = editAggregation;
              d.sort_order = editSortOrder;
              d.limit = parseInt(editXlimit);
              d.date_part = dateAtt;
              d.span_on = spaningOn;
              d.config_filters =
                attrLevelObjectforBreakdown?.[i]?.config_filters;
            }
            if (d?.date_aggregation) delete d?.date_aggregation;
            return d;
          }
        );

        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`filter_dropdown`]: [...updatedFilterDropdown],
            [`edit_fields`]: {
              ...axisPanelAtt?.edit_fields,
              boolValue: false,
            },
          })
        );
      } else if (editseries === "multilevel_breakdown") {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`multilevel_breakdown`]: {
              ...axisPanelAtt?.multilevel_breakdown,
              limit: parseInt(editXlimit),
            },
            [`edit_fields`]: {
              ...axisPanelAtt?.edit_fields,
              boolValue: false,
            },
          })
        );
      }
    } else if (editPanel?.chart_type === "sankey") {
      // this runs when APPLY button in edit panel is hit in case of sankey
      if (editseries === "x_axis") {
        dispatch(
          setX_attribute({
            ...axisPanelAtt,
            [`x_axis`]: {
              attribute: editPanel.attName,
              data_source: editPanel?.data_source,
              deep_dive_info: axisPanelAtt?.x_axis?.deep_dive_info
                ? axisPanelAtt?.x_axis?.deep_dive_info
                : editPanel?.deep_dive_info,
              trace_name: editName,
              aggregation: editAggregation,
              date_part:
                All_WM_attributes[editPanel.attName] === "Date" ||
                editPanel.attName === "RecordDate" ||
                editPanel.attName === "recorddate" ||
                editPanel.attName === "InsertedDate"
                  ? editDatePart === "null"
                    ? null
                    : editDatePart
                  : null,
              frequency: null,
              sort_order: editSortOrder,
              x_limit: parseInt(editXlimit),
              span_on: spaningOn,
              config_filters: attrLevelObjectforXaxis?.config_filters,
            },
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
            },
          })
        );
      }
      if (editseries === "breakdown") {
        const updatedBreakdown = axisPanelAtt?.breakdown_by?.map((d, i) => {
          let dateAtt =
            All_WM_attributes[editPanel.attName] === "Date" ||
            editPanel.attName === "RecordDate" ||
            editPanel.attName === "recorddate" ||
            editPanel.attName === "InsertedDate"
              ? editDatePart === "null"
                ? null
                : editDatePart
              : null;

          d.attribute = attrLevelObjectforBreakdown?.[i]?.attribute;
          d.data_source = attrLevelObjectforBreakdown?.[i]?.data_source;
          d.deep_dive_info =
            attrLevelObjectforBreakdown?.[i]?.deep_dive_info || null;
          d.trace_name = editName;
          d.aggregation = editAggregation;
          d.y_limit = parseInt(editXlimit);
          d.date_part = dateAtt;
          d.span_on = spaningOn;
          d.config_filters = attrLevelObjectforBreakdown?.[i]?.config_filters;
          if (d?.date_aggregation) delete d?.date_aggregation;
          return d;
        });

        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`breakdown_by`]: [...updatedBreakdown],
            [`edit_fields`]: {
              ...axisPanelAtt?.edit_fields,
              boolValue: false,
            },
          })
        );
      }
    } else {
      dispatch(
        setX_attribute({
          ...axisPanelAtt,
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        })
      );
      getEmptyFieldNotification();
    }
  };

  const handleChangeName = (e) => {
    setEditName(e.target.value);
  };
  const handleChangeInfoText = (e) => {
    setInfoText(e?.target?.value);
  };
  const closeEditFields = () => {
    let data = {
      boolValue: false,
      series: editseries,
      attName: editPanel,
    };
    dispatch(setChartEditField(data, axisPanelAtt));
  };

  const removeLimit = () => {
    setIslimet(!islimet);
    if (islimet) {
      setEditXlimit(0);
    } else if (editXlimit === 0) {
      setEditXlimit(1);
    }
  };
  const onChange = (key) => {
    setCollapseActiveKey(key);
  };

  // Reset collapse state when component renders or editPanel changes
  useEffect(() => {
    setCollapseActiveKey([]);
  }, [editPanel]);

  // Expose applyEditPanel to parent component
  useEffect(() => {
    if (onApply) {
      onApply(() => applyEditPanel());
    }
  }, [
    onApply,
    editName,
    editAggregation,
    editDatePart,
    editSortOrder,
    editXlimit,
    spaningOn,
    percent,
    infoText,
    variableSizeOn,
  ]);

  // Call onEditXlimitChange when editXlimit changes
  useEffect(() => {
    if (onEditXlimitChange) {
      onEditXlimitChange(editXlimit);
    }
  }, [editXlimit, onEditXlimitChange]);

  return (
    <div className="w-100">
      <div
        className="body p-15 custom_scroll1"
        style={{ maxHeight: "calc(100vh - 19.8rem)", overflow: "auto" }}
      >
        {((editseries?.split("_")[0] === "kpi" && !editPanel?.x_axis) ||
          editPanel?.chart_type === "combination" ||
          editPanel?.chart_type === "bar" ||
          editPanel?.chart_type === "horizontal-bar" ||
          editPanel?.chart_type === "lollipop" ||
          editPanel?.chart_type === "area" ||
          editPanel?.chart_type === "progress-kpi" ||
          editPanel?.chart_type === "line" ||
          editPanel?.chart_type === "heatmap" ||
          (editPanel?.chart_type === "kpi" &&
            !axisPanelAtt?.x_axis?.attribute) ||
          editPanel?.chart_type === "sankey" ||
          editseries === "x_axis" ||
          editseries === "breakdown" ||
          editseries === "filter_dropdown" ||
          (editseries === "filter_by" &&
            ["wordcloud", "post-card", "review-card"]?.includes(
              editPanel?.chart_type
            )) ||
          // editseries === "group_by" ||
          (editseries?.split("_")[0] === "y" &&
            (editPanel?.chart_type === "grid" ||
              editPanel?.chart_type === "cluster-chart")) ||
          editseries === "x_axis" ||
          (editseries === "breakdown" &&
            editPanel?.chart_type === "pivot-grid")) &&
          // Show name field for group_by when no attribute is selected
          (editseries !== "group_by" || !editPanel?.attName) &&
          editPanel?.chart_type !== "pie" &&
          editPanel?.chart_type !== "donut" &&
          editPanel?.chart_type !== "bubble" &&
          (editPanel?.chart_type !== "wordcloud" ||
            (editseries === "filter_by" &&
              ["wordcloud", "post-card", "review-card"]?.includes(
                editPanel?.chart_type
              ))) &&
          editPanel?.chart_type !== "map" &&
          editPanel?.chart_type !== "sunburst" && (
            <>
              <div className="floating-label-group header-brands">
                <Input
                  type="text"
                  value={editName}
                  onChange={handleChangeName}
                  maxLength="50"
                  style={{ paddingRight: "4rem" }}
                  className="border-radius-4 border-color"
                />
                <label
                  className="portlet-label floating-label bg__white font-size12"
                  style={{ top: "-0.8rem" }}
                >
                  Name
                </label>
                <span
                  className="position-absolute text_regular-gray font-size12"
                  style={{ top: "1.2rem", right: "0.4rem" }}
                >
                  {editName?.length}/50
                </span>
              </div>
              {editName !== All_WM_attributes?.[editPanel?.attName] && (
                <div
                  className="blue-text mb-15 mt-1 cursor-pointer"
                  onClick={() =>
                    setEditName(All_WM_attributes?.[editPanel?.attName])
                  }
                >
                  Restore to default name
                </div>
              )}
            </>
          )}

        {(editseries?.split("_")[0] === "kpi" && !editPanel?.x_axis) ||
        (editPanel?.chart_type === "kpi" && !axisPanelAtt?.x_axis?.attribute) ||
        (editseries === "group_by" && !editPanel?.attName) ? (
          <>
            <Collapse
              bordered={false}
              className="InfoText__Collapse bg__white p-0 pb-15 "
              expandIconPosition="right"
              activeKey={collapseActiveKey}
              onChange={onChange}
              accordion
            >
              <Panel
                // collapsible={!widgetMakerGraphData ? "disabled" : ""}
                className="border border-color border-radius-4"
                header={
                  <span className="portlet-label floating-label">
                    Info Text
                  </span>
                }
                key="info_text_panel"
              >
                <div className="position-relative floating-label-group header-brands">
                  <TextArea
                    rows={3}
                    id="outlined-required"
                    multiline
                    className="border-radius-4 border-color"
                    maxLength={150}
                    value={infoText}
                    onChange={(e) => handleChangeInfoText(e)}
                    style={{ resize: "none", padding: "0.8rem 1rem" }}
                    placeholder={"Enter info text"}
                  />
                  {/* <label className="portlet-label floating-label">
                    Info Text
                  </label> */}
                  <span
                    className="text-gray position-absolute font-size12"
                    style={{
                      right: "0.2rem",
                      bottom: "0.1rem",
                    }}
                  >
                    {infoText?.length > 0 ? infoText?.length : "0"}
                    /150
                  </span>
                </div>
              </Panel>
            </Collapse>
          </>
        ) : (
          ""
        )}
        {editPanel?.chart_type === "grid" && editPanel?.attName === "tagid" && (
          <div className="d-flex justify-content-between mb-10">
            <Checkbox
              value="Show Data Labels"
              className="text_regular d-flex m-0 mb-2"
              onChange={handleCheckBox}
              checked={percent}
            >
              Percent
            </Checkbox>
          </div>
        )}
        {editPanel?.chart_type === "grid" &&
          (editseries === "x_axis" || editseries === "breakdown") && (
            <div className="d-flex justify-content-between mb-10">
              <Checkbox
                value="ApplySpaningOn"
                className="text_regular d-flex m-0 mb-2"
                onChange={() => {
                  setSpaningOn(!spaningOn);
                }}
                checked={spaningOn}
                disabled={editPanel?.span_disabled ? true : false}
              >
                Enable row spanning
                <Tooltip
                  title={
                    editPanel?.span_disabled
                      ? editPanel?.span_disabled_msg
                        ? editPanel?.span_disabled_msg
                        : "Spanning on " + editName + " disabled."
                      : "Spanning on this column will group data row wise"
                  }
                >
                  <i
                    className="fa fa-info-circle cursor-pointer ml-1"
                    style={
                      editPanel?.span_disabled
                        ? { color: "#A020F0" }
                        : { color: "#869dad" }
                    }
                  />
                </Tooltip>
              </Checkbox>
            </div>
          )}
        {editPanel?.chart_type === "scatter" &&
          editseries?.includes("y_series") && (
            <div className="d-flex justify-content-between mb-10">
              <Checkbox
                value="ApplyVariableSizeOn"
                className="text_regular d-flex m-0 mb-2"
                onChange={() => {
                  setVariableSizeOn(!variableSizeOn);
                }}
                checked={variableSizeOn}
                disabled={editPanel?.variable_size_disabled ? true : false}
              >
                Variable Size
                <Tooltip
                  title={
                    editPanel?.variable_size_disabled
                      ? editPanel?.variable_size_msg
                        ? editPanel?.variable_size_msg
                        : "Variable sizing on " + editName + " disabled."
                      : "Size of marker will be determined by the value of " +
                        editName +
                        "."
                  }
                >
                  <i
                    className="fa fa-info-circle cursor-pointer ml-2"
                    style={
                      editPanel?.variable_size_disabled
                        ? { color: "#A020F0" }
                        : { color: "#869dad" }
                    }
                  />
                </Tooltip>
              </Checkbox>
            </div>
          )}

        {!(
          editseries === "group_by" ||
          editseries === "x_axis" ||
          editseries === "breakdown" ||
          editseries === "order_by"
        ) &&
          editseries !== "filter_dropdown" &&
          editseries !== "filter_by" &&
          (editseries?.split("_")[0] === "kpi" ||
            editPanel?.chart_type === "combination" ||
            editPanel?.chart_type === "scatter" ||
            editPanel?.chart_type === "multilayer-map" ||
            editPanel?.chart_type === "bar" ||
            editPanel?.chart_type === "horizontal-bar" ||
            editPanel?.chart_type === "lollipop" ||
            editPanel?.chart_type === "area" ||
            editPanel?.chart_type === "line" ||
            editPanel?.chart_type === "pie" ||
            editPanel?.chart_type === "donut" ||
            editPanel?.chart_type === "bubble" ||
            editPanel?.chart_type === "wordcloud" ||
            editPanel?.chart_type === "kpi" ||
            editPanel?.chart_type === "map" ||
            editPanel?.chart_type === "heatmap" ||
            editPanel?.chart_type === "sunburst" ||
            editPanel?.chart_type === "pivot-grid" ||
            editPanel?.chart_type === "treemap" ||
            editPanel?.chart_type === "grid") && (
            <div className="floating-label-group header-brands mb-15">
              <Select
                defaultValue={
                  graphConditionAggregation?.avg?.includes(
                    editPanel?.attName
                  ) ||
                  graphConditionAggregation?.average_attribute?.includes(
                    // For mentions attribute
                    editPanel?.attName
                  )
                    ? "avg"
                    : "count"
                }
                value={editAggregation}
                onChange={(e) => setAggregation(e)}
                className="w-100"
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                {graphConditionAggregation?.count_distinct?.includes(
                  editPanel?.attName
                ) ? (
                  <>
                    <Option key={1} value="count">
                      Count
                    </Option>
                    <Option key={2} value="avg">
                      Average per Day
                    </Option>
                  </>
                ) : graphConditionAggregation?.count?.includes(
                    editPanel?.attName
                  ) ? (
                  <>
                    <Option key={1} value="count">
                      Count
                    </Option>
                  </>
                ) : graphConditionAggregation?.min?.includes(
                    editPanel?.attName
                  ) &&
                  graphConditionAggregation?.max?.includes(
                    editPanel?.attName
                  ) ? (
                  <>
                    <Option key={1} value="max">
                      Max
                    </Option>
                    <Option key={2} value="min">
                      Min
                    </Option>
                  </>
                ) : graphConditionAggregation?.max?.includes(
                    editPanel?.attName
                  ) ? (
                  <>
                    <Option key={1} value="max">
                      Max
                    </Option>
                  </>
                ) : editPanel?.attName === "nss" ||
                  editPanel?.attName === "srs" ? (
                  <>
                    <Option key={1} value="count">
                      Count
                    </Option>
                    <Option key={2} value="distinct">
                      Unique User
                    </Option>
                  </>
                ) : graphConditionAggregation?.avg?.includes(
                    editPanel?.attName
                  ) ? (
                  <>
                    <Option key={2} value="min">
                      Min
                    </Option>
                    <Option key={3} value="max">
                      Max
                    </Option>
                    <Option key={4} value="avg">
                      Average per Ticket
                    </Option>
                    <Option key={5} value="sum">
                      Sum
                    </Option>
                  </>
                ) : graphConditions?.[`latest-agg-columns`]?.includes(
                    editPanel?.attName
                  ) ? (
                  <>
                    <Option key={1} value="latest">
                      Latest
                    </Option>
                    {/* <Option key={2} value="min">
                      Min
                    </Option>
                    <Option key={3} value="max">
                      Max
                    </Option>
                    <Option key={4} value="sum">
                      Sum
                    </Option> */}
                  </>
                ) : (
                  <>
                    <Option key={2} value="min">
                      Min
                    </Option>
                    <Option key={3} value="max">
                      Max
                    </Option>
                    <Option key={4} value="avg">
                      Average per Post
                    </Option>
                    <Option key={5} value="sum">
                      Sum
                    </Option>
                    {graphConditions?.[`time-label-attrs`]?.includes(
                      editPanel?.attName
                    ) ? (
                      <Option key={6} value="95th_percentile">
                        95th Percentile
                      </Option>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Aggregation
              </label>
            </div>
          )}

        {(All_WM_attributes[editPanel.attName] === "Date" ||
          editPanel.attName === "RecordDate" ||
          editPanel.attName === "recorddate" ||
          editPanel.attName === "InsertedDate") &&
          (editPanel.series === "x_axis" ||
            ([
              "pivot-grid",
              // "combination",
              // "bar",
              // "horizontal-bar",
              // "lollipop",
              // "area",
              // "line",
              "heatmap",
            ]?.includes(editPanel?.chart_type) &&
              editPanel.series === "breakdown")) && (
            <div className="floating-label-group header-brands mb-15">
              <Select
                defaultValue={editDatePart === "null" ? "Date" : editDatePart}
                value={editDatePart === "null" ? "Date" : editDatePart}
                onChange={(e) => setEditDatePart(e)}
                className="w-100"
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                {optionList?.timeList?.map((list, i) => {
                  return (
                    <Option value={list} key={i}>
                      {(list === null && "Date") ||
                        (list === "hh" && "Hour of day") ||
                        (list === "dd" && "Day of Month") ||
                        (list === "dw" && "Day of Week") ||
                        (list === "mm" && "Month of Year") ||
                        (list === "ww" && "Week of Year") ||
                        (list === "qq" && "Quarter of Year")}
                    </Option>
                  );
                })}
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Date Part
              </label>
            </div>
          )}

        {![
          "pivot-grid",
          // "combination",
          // "bar",
          // "horizontal-bar",
          // "lollipop",
          // "area",
          // "line",
          "heatmap",
        ]?.includes(editPanel?.chart_type) &&
          (All_WM_attributes[editPanel.attName] === "Date" ||
            editPanel.attName === "RecordDate" ||
            editPanel.attName === "recorddate" ||
            editPanel.attName === "InsertedDate") &&
          editPanel.series === "breakdown" && (
            <div className="floating-label-group header-brands mb-15">
              <Select
                defaultValue={editDatePart}
                value={editDatePart}
                onChange={(e) => setEditDatePart(e)}
                className="w-100"
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Option key={1} value="ww">
                  Week of Year
                </Option>
                <Option key={2} value="mm">
                  Month of Year
                </Option>
                <Option key={3} value="qq">
                  Quarter of Year
                </Option>
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Date Part
              </label>
            </div>
          )}

        {(editseries === "group_by" ||
          (editseries === "x_axis" &&
            editPanel?.chart_type === "combination") ||
          (editseries === "x_axis" && editPanel?.chart_type === "bar") ||
          (editseries === "x_axis" &&
            editPanel?.chart_type === "horizontal-bar") ||
          (editseries === "x_axis" && editPanel?.chart_type === "lollipop") ||
          (editseries === "x_axis" && editPanel?.chart_type === "lollipop") ||
          (editseries === "x_axis" && editPanel?.chart_type === "area") ||
          (editseries === "x_axis" && editPanel?.chart_type === "line") ||
          editseries === "order_by") &&
          (editPanel?.chart_type !== "pie" ||
            editPanel?.chart_type !== "donut" ||
            editPanel?.chart_type !== "grid") &&
          // to hide the sort option for date in x-axis
          editseries === "x_axis" &&
          All_WM_attributes[editPanel.attName] !== "Date" &&
          editPanel.attName !== "RecordDate" &&
          editPanel.attName !== "recorddate" &&
          editPanel.attName !== "InsertedDate" && (
            <div className="floating-label-group header-brands mb-15">
              <Select
                defaultValue={editSortOrder}
                value={editSortOrder}
                onChange={(e) => setEditSortOrder(e)}
                className="w-100"
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Option key={0} value="asc">
                  Ascending
                </Option>
                <Option key={1} value="desc">
                  Descending
                </Option>
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Sort Order
              </label>
            </div>
          )}

        {(editPanel?.chart_type === "network-graph" ||
          editPanel?.chart_type === "network-graph-v2") &&
        (editseries === "x_axis" || editseries === "breakdown") ? (
          <>
            {" "}
            <div className="floating-label-group header-brands mb-15">
              <Select
                defaultValue={radiusAttribute}
                value={radiusAttribute}
                onChange={(e) => setRadiusAttribute(e)}
                className="w-100"
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                {radiusOptions
                  ?.map((op) => {
                    if (
                      editPanel.attName &&
                      graphConditions?.["network-graph"]?.order_by?.exclude?.[
                        editPanel?.attName?.toLowerCase()
                      ]
                        ? !graphConditions?.[
                            "network-graph"
                          ]?.order_by?.exclude?.[
                            editPanel?.attName?.toLowerCase()
                          ]?.includes(op?.attribute)
                        : true
                    ) {
                      return (
                        <Option value={op?.attribute}>{op?.trace_name}</Option>
                      );
                    } else {
                      return null;
                    }
                  })
                  ?.filter((e) => e)}
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-8px" }}
              >
                Size Based On
              </label>
            </div>
            <div className="floating-label-group header-brands mb-15">
              <WordCloudColorPalate
                type="editField"
                onChangeSeriesColor={(value) => {
                  setSeriesColor(value);
                }}
                seriesColor={
                  seriesColor
                    ? seriesColor
                    : editPanel?.seriesColor
                    ? editPanel?.seriesColor
                    : null
                }
              />
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-8px" }}
              >
                Node Colour
              </label>
            </div>
          </>
        ) : (
          ""
        )}

        {editseries === "breakdown" &&
        editPanel?.chart_type === "pivot-grid" ? (
          <>
            <div className="d-flex justify-content-between">
              <span className="font-size12 text-Darkgray">Limit</span>
            </div>
            <div className={`mt-2 text_regular-gray font-size12 `}>
              For user configurable attributes, data is capped to 10
              columns(values).
            </div>
          </>
        ) : (
          (editseries === "group_by" ||
            editseries === "filter_dropdown" ||
            (editseries === "x_axis" &&
              editPanel?.chart_type !== "pivot-grid") ||
            (editseries === "breakdown" &&
              editPanel?.chart_type !== "pivot-grid" &&
              editPanel?.chart_type !== "grid") ||
            // &&
            // editPanel?.chart_type !== "pivot-grid"
            editseries === "order_by") &&
          All_WM_attributes[editPanel.attName] !== "Date" &&
          editPanel.attName !== "recorddate" && (
            <>
              <div className="d-flex justify-content-between">
                <span className="font-size12 text-Darkgray">Limit</span>
                <span
                  className="blue-text font-size12 cursor-pointer"
                  onClick={removeLimit}
                >
                  {" "}
                  {islimet ? "Remove limit" : "+Set limit"}
                </span>
              </div>
              <div className={`w-100 ${islimet ? "" : "d-none"}`}>
                {editPanel?.chart_type === "sankey" ? (
                  <span>you cannot change the set limit for Sankey</span>
                ) : (
                  ""
                )}
                <div className="floating-label-group d-flex align-items-center mt-15">
                  <Select
                    defaultValue="top"
                    value={editSortOrder === "asc" ? "bottom" : "top"}
                    className="w-100"
                    dropdownClassName={
                      authParams?.theme_type === "1"
                        ? "darkTheme"
                        : "lightTheme"
                    }
                    onChange={(value) =>
                      setEditSortOrder(value === "bottom" ? "asc" : "desc")
                    }
                  >
                    <Option key={0} value="top">
                      Top
                    </Option>
                    <Option key={1} value="bottom">
                      Bottom
                    </Option>
                  </Select>
                  <Input
                    type="number"
                    min={1}
                    value={editPanel?.chart_type === "sankey" ? 10 : editXlimit}
                    disabled={editPanel?.chart_type === "sankey"}
                    onChange={(e) => {
                      // Don't allow changes for sankey chart
                      if (editPanel?.chart_type === "sankey") {
                        return;
                      }

                      setEditXlimitError(false);
                      const inputValue = e.target.value;

                      // Allow empty string for deletion
                      if (inputValue === "") {
                        setEditXlimit("");
                        setEditXlimitError(true);
                        return;
                      }

                      // Only allow numeric input
                      if (!/^\d*$/.test(inputValue)) {
                        return;
                      }

                      // Remove leading zeros except for single "0"
                      let cleanedValue = inputValue.replace(/^0+/, "") || "0";
                      const numValue = parseInt(cleanedValue, 10);

                      if (numValue <= 0) {
                        setEditXlimitError(true);
                      }

                      // Apply limits based on series type but always update the input
                      if (editPanel?.chart_type === "cluster-chart") {
                        if (numValue <= 10) {
                          setEditXlimit(cleanedValue);
                        }
                      } else if (
                        editseries === "breakdown" ||
                        editseries === "filter_dropdown"
                      ) {
                        if (numValue <= 50) {
                          setEditXlimit(cleanedValue);
                        }
                      } else if (editseries === "group_by") {
                        if (numValue <= 15) {
                          setEditXlimit(cleanedValue);
                        }
                      } else if (numValue <= 9999) {
                        setEditXlimit(cleanedValue);
                      }
                    }}
                  />
                </div>
                <div
                  className={`position-relative font-size12 ${
                    editXlimitError ? "error" : "text-gray"
                  }`}
                >
                  {`Note: Allowed Range: ${
                    axisPanelAtt?.chart_type === "cluster-chart"
                      ? "1-10"
                      : editseries === "breakdown" ||
                        editseries === "filter_dropdown"
                      ? "1-50"
                      : editseries === "group_by"
                      ? "1-15"
                      : "1-9999"
                  }.`}
                </div>
                <div className="floating-label-group d-none align-items-center mt-15 mb-1">
                  <label className="portlet-label font-size12 font-weight600 mr-2">
                    By
                  </label>
                  <Select
                    defaultValue="unique"
                    className="w-100"
                    dropdownClassName={
                      authParams?.theme_type === "1"
                        ? "darkTheme"
                        : "lightTheme"
                    }
                  >
                    <Option key={0} value="unique">
                      Unique Users
                    </Option>
                    <Option key={1} value="engagement">
                      Engagement
                    </Option>
                  </Select>
                </div>
              </div>
              <div
                className={`text_regular-gray font-size12 ${
                  islimet ? "d-none" : ""
                }`}
              >
                Click on 'Set limit' to limit the number of values for this
                field
              </div>
            </>
          )
        )}
      </div>
      {/*handleUpdatedAttrLevelBreakdown || handleUpdatedAttrLevelXaxis */}
      {(editPanel?.chart_type === "combination" ||
        editPanel?.chart_type === "bar" ||
        editPanel?.chart_type === "pie" ||
        editPanel?.chart_type === "donut" ||
        editPanel?.chart_type === "horizontal-bar" ||
        editPanel?.chart_type === "lollipop" ||
        editPanel?.chart_type === "area" ||
        editPanel?.chart_type === "kpi" ||
        editPanel?.chart_type === "progress-kpi" ||
        editPanel?.chart_type === "line" ||
        editPanel?.chart_type === "grid" ||
        editPanel?.chart_type === "sankey") &&
      (editPanel?.series === "breakdown" || editPanel?.series === "x_axis") ? (
        <AttributeConfigurePanel
          setBreakdownProp={handleUpdatedAttrLevelBreakdown}
          setXaxisProp={handleUpdatedAttrLevelXaxis}
          editPanel={editPanel}
        />
      ) : (
        ""
      )}

      {/* <div className="p-15 border-top text-left">
        <Button
          style={{ color: "#fff" }}
          disabled={
            editName === "" || (islimet && editXlimitError) ? true : false
          }
          type="primary"
          className="ant-btn-primary_blue mr-15"
          onClick={applyEditPanel}
        >
          Apply
        </Button>
        <Button className="btn_Clear" onClick={closeEditFields}>
          Cancel
        </Button>
      </div> */}
    </div>
  );
};

export default EditFieldPanel;
